/**
 * Tipos de datos para campos de formulario
 */
export enum TYPES {
  reference = 'reference',
  date = 'date',
  color = 'color',
  number = 'number',
  text = 'text',
  string = 'string',
  textarea = 'textarea',
  dropdown = 'dropdown',
  checkbox = 'checkbox',
  radio = 'radio',
  file = 'file',
  file_input = 'file-input',
  check = 'check',
  rating = 'rating',
}

/**
 * Tipos de datos para columnas en tabla
 */
export enum TYPES_COLUMN {
  tag = 'tag',
  large = 'large',
  date = 'date',
  number = 'number',
  text = 'text',
  percent = 'percent',
  currency = 'currency',
  string = 'string',
  color = 'color'
}

/**
 * Tipos de formatos de documentos
 */
export enum TYPES_FILE {
  pdf = 'application/pdf',
  allImages = 'image/jpeg,image/gif,image/png',
  gif = 'image/gif',
  all = 'image/jpeg,image/gif,image/png,application/pdf'
}

export interface InfoEvent {
  restaurant_id: string;
  type: string;
  product_id: string;
  menu_type?: string;
  social_media?: string;
  /** Segundos que el usuario permaneció viendo el menú (evento menu_time_spent) */
  duration_seconds?: number;
}


